module.exports = __webpack_public_path__ + "img/illustration-intro.526544ae.png";